import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Text, Heading } from 'components/common/Elements/Elements';

import classes from './CustomTooltip.module.scss';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length > 0) {
    return (
      <div className={classes.box}>
        <Heading className={classes.title}>{label}</Heading>
        {payload.map(item => {
          return (
            <Text type="p" className={classes.item} key={item.dataKey}>
              <Text>
                <img
                  alt=""
                  className={classes.color}
                  style={{ backgroundColor: item.color }}
                />
                <Text className={classes.name}>{item.name}:</Text>
              </Text>
              <Text className={classes.text}>{item.value}</Text>
            </Text>
          );
        })}
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  payload: PropTypes.arrayOf(object),
  active: PropTypes.bool,
  label: PropTypes.string
};

export default CustomTooltip;
